/**
 * SearchIcon - Such-Icon für die Titlebar
 *
 * Zeigt eine Lupe. Ersetzt das Lucide `Search` Icon in der Titlebar.
 *
 * @example
 * ```tsx
 * <SearchIcon />
 * <SearchIcon size={18} />
 * ```
 */
export const SearchIcon = ({ size = 14 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.67 12.66L9.8 9.8M11.33 6C11.33 8.94 8.94 11.33 6 11.33C3.05 11.33 0.67 8.94 0.67 6C0.67 3.05 3.05 0.67 6 0.67C8.94 0.67 11.33 3.05 11.33 6Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
